import Modal from './base.modal'
import Button, { type ButtonProps } from '../ui/button'
import type { ModalComponentProps } from '../../types/modal.types'
import { cn } from '../../utils/cn.utils';

interface DialogProps extends ModalComponentProps {
  className?: string;
  children?: React.ReactNode
  title: string
  enableOutsideClick?: boolean
  content?: string
  leftButton?: {
    title?: string
    onClick?: () => void
  }
  rightButton?: {
    title?: string
    onClick?: () => void
    disabled?: boolean
    variant?: ButtonProps['variant']
  }
}

export default function ConfirmDialog(props: DialogProps) {
  const { id, onClose, title, content, leftButton, rightButton, children, className, enableOutsideClick = true } = props

  return (
    <Modal id={id} className={cn("p-4 pt-6", className)} size="default" close={onClose} enableOutsideClick={enableOutsideClick}>
      <section>
        <p className="text-style-body-05 font-normal">{title}</p>
        {content && (<p className="text-style-body-03 font-normal text-gray-50">{content}</p>)}
      </section>
      {children && children}
      <section className="mt-7 flex-row gap-4 justify-end">
        <Button
          // className="w-full"
          label={leftButton?.title || '취소'}
          variant={"outline"}
          onClick={() => {
            leftButton?.onClick?.()
            onClose?.()
          }}
        />
        <Button
          // className="w-full"
          onClick={() => {
            rightButton?.onClick?.()
          }}
          variant={rightButton?.variant || "primary"}
          disabled={rightButton?.disabled}
          label={rightButton?.title || '확인'}
        />
      </section>
    </Modal>
  )
}
